import Vue from 'vue'
import Vuex from 'vuex'

// modules
import auth from './modules/auth'
import settings from './modules/settings'
import general from './modules/general'
//--pendientes
import chat from './modules/chat'
import ecommerce from './modules/ecommerce'
import mail from './modules/mail'

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        auth,
        settings,
        general,
        chat,
        mail,
        ecommerce
    }
})
